module.exports = __webpack_public_path__ + "img/tu04.fb951f47.jpg";